/* eslint-disable react/no-unused-state */
import React, { PropTypes, Component } from 'react'
import merge from 'lodash/merge'
import TextInput from 'components/Form/components/TextInput'
import Filters from 'components/List/components/Filters'
import { getFiscalYearTimestamps } from 'utils/fiscalYear'
import constants from 'constants'

const styles = Object.assign(
  {},
  require('./PartnerPlanFilter.scss'),
)

class PartnerPlanFilter extends Component {
  static propTypes = {
    filteredPartnerPlans: PropTypes.instanceOf(Array),
    onChangeFilteredPartnerPlans: PropTypes.func,
    onClearFilteredPartnerPlans: PropTypes.func,
    onPlanStatusSearchTrigger: PropTypes.func,
    onPlanYearSearchTrigger: PropTypes.func,
    onTextSearchTrigger: PropTypes.func,
    partnerPlans: PropTypes.object,
  }

  static defaultProps = {
    filteredPartnerPlans: [],
    onChangeFilteredPartnerPlans: null,
    onClearFilteredPartnerPlans: null,
    onPlanStatusSearchTrigger: null,
    onPlanYearSearchTrigger: null,
    onTextSearchTrigger: null,
    partnerPlans: null,
  }

  constructor(props) {
    super(props)
    // this.handleInitFilteredPersonalInfo = this.handleInitFilteredPersonalInfo.bind(this);
    // this.handleChangeFilteredPersonalInfos = this.handleChangeFilteredPersonalInfos.bind(this);
    this.data = []
    this.state = {
      planStatus: '',
      planYear: '',
      planSearch: '',
      typing: false,
      typingTimeout: 0,
      filters: {
        planStatus: null,
        planYear: null,
        planSearch: null,
      },
      filterData: {
        planStatus: constants.LIST_DYNAMICFILTERS('PlanStatus', this.props.partnerPlans.planStatus),
        planYear: constants.LIST_DYNAMICFILTERS('PlanYear', this.props.partnerPlans.planYear),
      },
    }
  }

  componentDidMount() {
    /* const filters = this.state.filters
    const newFilters = merge({}, filters, {
      status: (this.props.personalinfos.selectedStatusFilter === 1 ? 'Active' : 'Inactive'),
    })
    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({ filters: newFilters }) */

    const { filters } = this.state
    let filterSelection = ''
    if (sessionStorage.getItem(constants.PARTNERPLAN.SEARCHSESSIONKEY.FILTER)) {
      filterSelection = JSON.parse(sessionStorage.getItem(constants.PARTNERPLAN.SEARCHSESSIONKEY.FILTER))
      if (filterSelection.planYear) {
        // eslint-disable-next-line react/no-did-mount-set-state
        // this.setState({ selPlanYear: filterSelection.year })
        setTimeout(() => { this.setState({ planYear: filterSelection.planYear }) }, 800)
      }
      if (filterSelection.planStatus) {
        // eslint-disable-next-line react/no-did-mount-set-state
        // this.setState({ selPlanStage: filterSelection.stage })
        setTimeout(() => { this.setState({ planStatus: filterSelection.planStatus }) }, 800)
      }
      if (filterSelection.planSearch) {
        // eslint-disable-next-line react/no-did-mount-set-state
        // this.setState({ selPlanStage: filterSelection.stage })
        setTimeout(() => { this.setState({ planSearch: filterSelection.planSearch }) }, 800)
      }
      this.filterPartnerPlans(filterSelection.planYear, filterSelection.planStatus, filterSelection.planSearch)
    }
    const currentFY = this.props.onGetFilterValueFromSession(constants.PARTNERPLAN.SEARCHFILTERSTATE.INITIAL) ? getFiscalYearTimestamps().current.year : ''
    const newFilters = merge({}, filters, {
      planYear: (filterSelection ? filterSelection.planYear : currentFY),
      planStatus: (filterSelection ? filterSelection.planStatus : ''),
      planSearch: (filterSelection ? filterSelection.planSearch : ''),
    })
    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({ filters: newFilters })
  }

  componentWillReceiveProps(nextProps) {
    const { filteredPartnerPlans } = this.props
    this.data = filteredPartnerPlans
    if (nextProps.filteredPartnerPlans !== this.props.filteredPartnerPlans) {
      this.data = nextProps.filteredPartnerPlans
    }
  }

  _handleFocus = (name) => {
    // Create state value obj
    const stateValue = {
      field: name,
      data: {
        focus: true,
      },
    }
    // not in used the component needs this function to not to throw warnings
  }

  _handleChange = (name, value) => {
    // Create state value obj
    const stateValue = {
      field: name,
      data: {
        value,
        error: '',
        valid: true,
      },
    }

    const self = this

    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout)
    }

    self.setState({
      planSearch: stateValue.data.value,
      typing: false,
      typingTimeout: setTimeout(() => {
        const filterString = sessionStorage.getItem(constants.PARTNERPLAN.SEARCHSESSIONKEY.FILTER)
        const filterSelection = filterString ? JSON.parse(filterString) : null
        const planStatus = (filterSelection && filterSelection.planStatus != null) ? filterSelection.planStatus : self.state.filters.planStatus
        const planYear = (filterSelection && filterSelection.planYear != null) ? filterSelection.planYear : self.state.filters.planYear
        self.filterPartnerPlans(planStatus, planYear, self.state.planSearch)
      }, 2000),
    })

    this.setState({ planSearch: stateValue.data.value })
    this.setState((prevState) => {
      return {
        filters: Object.assign({}, prevState.filters, {
          planSearch: stateValue.data.value,
        }),
      }
    })
  }

  _handleValidation = (name) => {
    const stateValue = {
      field: name,
      data: {
        focus: false,
      },
    }
    // not in used the component needs this function to not to throw warnings
  }

  filterByPlanStatus = (data, filtervalue) => {
    this.props.onPlanStatusSearchTrigger(true)
    this.updateFilterSessionObject(constants.PARTNERPLAN.SEARCHFILTER.STATUS, filtervalue)
    // eslint-disable-next-line eqeqeq
    return data.filter(item => item.planStatus == filtervalue)
  }

  filterByPlanYear = (data, filtervalue) => {
    this.props.onPlanYearSearchTrigger(true)
    this.updateFilterSessionObject(constants.PARTNERPLAN.SEARCHFILTER.YEAR, filtervalue)
    // eslint-disable-next-line eqeqeq
    return data.filter(item => item.year == filtervalue)
  }

  filterByName = (data, filtervalue) => {
    this.updateFilterSessionObject(constants.PARTNERPLAN.SEARCHFILTER.TEXT, filtervalue)
    if (filtervalue) {
      return data.filter(item => (item.name.toLowerCase().includes(filtervalue.toLowerCase().trim())))
    }
    return data
  }

  filterPartnerPlans = (planStatus, planYear, partnername) => {
    let filteredinfo = [...new Set(this.props.partnerPlans.partnerPlans)]
    if (planStatus) {
      filteredinfo = this.filterByPlanStatus(filteredinfo, planStatus)
    }
    if (planYear) {
      filteredinfo = this.filterByPlanYear(filteredinfo, planYear)
    }
    if (partnername) {
      filteredinfo = this.filterByName(filteredinfo, partnername)
      this.props.onTextSearchTrigger(true)
    } else {
      this.props.onTextSearchTrigger(false)
    }
    this.props.onChangeFilteredPartnerPlans(filteredinfo)
  }

  clearFilters = () => {
    this.setState({
      planSearch: '',
      planStatus: '',
      planYear: '',
      filters: {
        planStatus: null,
        planYear: null,
        planSearch: null,
      },
    })
    this.props.onClearFilteredPartnerPlans()
    sessionStorage.removeItem(constants.PARTNERPLAN.SEARCHSESSIONKEY.FILTER)
  }

  filter = ({ type = null, value = null }) => {
    // get current filters object from state
    const currentFilters = this.state.filters || {}

    // merge current filters with new filter value
    const newFilters = Object.assign({}, currentFilters, {
      [type]: value,
    })

    // Prepare the individual states based on type
    const newState = {
      filters: newFilters,
    }

    if (type === 'planStatus') {
      newState.planStatus = value
    } else if (type === 'planYear') {
      newState.planYear = value
    } else if (type === 'planSearch') {
      newState.planSearch = value
    }

    this.setState(newState, () => {
      // After state updates, call filterPartnerPlans with latest values
      this.filterPartnerPlans(
        (this.state.planStatus != null && this.state.planStatus !== '')
          ? this.state.planStatus
          : this.state.filters.planStatus,

        (this.state.planYear != null && this.state.planYear !== '')
          ? this.state.planYear
          : this.state.filters.planYear,

        (this.state.planSearch != null && this.state.planSearch !== '')
          ? this.state.planSearch
          : this.state.filters.planSearch,
      )
    })
  };

  updateFilterSessionObject = (filterBy, filterValue) => {
    let filterSelection = {
      planYear: '',
      planStatus: '',
      planSearch: '',
    }
    if (sessionStorage.getItem(constants.PARTNERPLAN.SEARCHSESSIONKEY.FILTER)) {
      filterSelection = JSON.parse(sessionStorage.getItem(constants.PARTNERPLAN.SEARCHSESSIONKEY.FILTER))
    }
    if (filterBy.toLowerCase() === constants.PARTNERPLAN.SEARCHFILTER.YEAR.toLowerCase()) {
      filterSelection.planYear = filterValue
    }
    if (filterBy.toLowerCase() === constants.PARTNERPLAN.SEARCHFILTER.STATUS.toLowerCase()) {
      filterSelection.planStatus = filterValue
    }
    if (filterBy.toLowerCase() === constants.PARTNERPLAN.SEARCHFILTER.TEXT.toLowerCase()) {
      filterSelection.planSearch = filterValue
    }

    sessionStorage.setItem(constants.PARTNERPLAN.SEARCHSESSIONKEY.FILTER, JSON.stringify(filterSelection))
  }

  render() {
    return (
      <section className={styles.section}>
        <div className={styles.searchinput}>
          <TextInput
            showSearchIcon
            handleChange={this._handleChange}
            label="Search"
            name="Search"
            onBlur={this._handleValidation}
            onFocus={this._handleFocus}
            text={this.state.planSearch}
          />
        </div>
        {/* <div className={styles.gridcontainerelement}> */}
        <div className={styles.gridfilterelement}>
          <div className={styles.gridchildfilterelement1}>
            <div />
          </div>
          <div className={styles.gridchildfilterelement2}>
            <Filters
              clearFilters={this.clearFilters}
              filter={this.filter}
              filterData={this.state.filterData}
              rules={this.state.filters}
            />
          </div>
        </div>
      </section>
    )
  }
}

export default PartnerPlanFilter



// WEBPACK FOOTER //
// ./src/views/PartnerReports/PartnerPlan/components/PartnerPlanFilter.js